import { InstitutionFuturesProgressStep } from '@/context/progress';
import FuturesClientCategorisationLayout from '@/features/futures/layouts/client-categorisation';
import ServicesAgreement from '@/features/services-agreement/components/agreement';

// Products asks for the LEI, so unlike the post-onboarding page there is no LEI step before this one
const InstitutionOnboardingFuturesServicesAgreementPage = () => {
  return (
    <FuturesClientCategorisationLayout step={InstitutionFuturesProgressStep.CLIENT_CATEGORISATION} fill>
      <ServicesAgreement next="/institution/onboarding/futures/client-categorisation/treatment" />
    </FuturesClientCategorisationLayout>
  );
};
InstitutionOnboardingFuturesServicesAgreementPage.displayName = 'InstitutionOnboardingFuturesServicesAgreementPage';

export default InstitutionOnboardingFuturesServicesAgreementPage;
